




























































import { DoseUnit, DoseUnitEnum, SelectItem } from "@/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ToRate extends Vue {
  @Prop()
  private weight!: number;

  private syringeDose = 0; // davka ve strikacce
  private syringeSize = 100; // velikost strikacky
  private syringeSizes: SelectItem[] = [
    {
      value: 250,
      title: "250 ml",
    },
    {
      value: 100,
      title: "100 ml",
    },
    {
      value: 50,
      title: "50 ml",
    },
    {
      value: 40,
      title: "40 ml",
    },
    {
      value: 20,
      title: "20 ml",
    },
    {
      value: 10,
      title: "10 ml",
    },
  ];
  private dose = 0; // pozadovana davka
  private doseUnit = 0; // jednotka pozadovane davky
  private doseUnits: DoseUnit[] = [
    {
      value: DoseUnitEnum["µg/kg/min"],
      title: "µg/kg/min",
    },
    {
      value: DoseUnitEnum["µg/kg/hod"],
      title: "µg/kg/hod",
    },
    {
      value: DoseUnitEnum["µg/min"],
      title: "µg/min",
    },
    {
      value: DoseUnitEnum["mg/hod"],
      title: "mg/hod",
    },
    {
      value: DoseUnitEnum["mg/kg/hod"],
      title: "mg/kg/hod",
    },
  ];

  get rate(): number {
    let dose = this.dose;
    switch (this.doseUnit) {
      case DoseUnitEnum["µg/kg/min"]:
        dose = this.dose * 0.06;
        break;
      case DoseUnitEnum["µg/kg/hod"]:
        dose = this.dose / 1000;
        break;
      case DoseUnitEnum["µg/min"]:
        dose = this.dose * 0.06;
        break;
    }

    let rate: number = (this.syringeSize * dose) / this.syringeDose;
    if (
      ![DoseUnitEnum["µg/min"], DoseUnitEnum["mg/hod"]].includes(this.doseUnit)
    )
      rate = rate * this.weight;
    return Math.round(rate * 10) / 10;
  }
}
